import { IconValues } from "../../../atoms/Icon/Icon.types";

export const getIcon = (skill: string): IconValues => {
  const s =
    String(skill).charAt(0).toLowerCase() +
    skill?.slice(1).replace(/-|\s/g, "");

  let result: IconValues = IconValues.logo;

  for (const key in IconValues) {
    let k: IconValues = key as IconValues;
    if (key === s) {
      result = k;
    }
  }

  return result;
};
